import { HeaderFastActionItem } from '@lib/types/cms/Header';
import { FastActionMenuItem } from './FastActionMenuItem';

type FastActionMenuProps = {
  showLoggedInOptions: boolean;
  items: HeaderFastActionItem[];
};

export const FastActionMenu = ({
  showLoggedInOptions,
  items,
}: FastActionMenuProps) => {
  const filterAuthOptions = (fastActionsMenuItem: HeaderFastActionItem) => {
    if (fastActionsMenuItem?.requiresLogIn) {
      return showLoggedInOptions;
    }
    return true;
  };

  const filteredItems = items.filter(filterAuthOptions);
  return (
    <div className="flex">
      {filteredItems.map((fastActionsMenuItem) => (
        <FastActionMenuItem
          item={fastActionsMenuItem}
          key={`${fastActionsMenuItem?.topLevelLink?.value}-${fastActionsMenuItem?.topLevelLink?.url}`}
        />
      ))}
    </div>
  );
};
